import Fleet from '../components/Fleet';
export default function FleetPage() { return <Fleet />; }
